import Home from '/public/pages/home2.svelte';
import ForgotPassword from '/public/pages/forgot-password.svelte';
import ResetPassword from '/public/pages/reset-password.svelte';
import Logout from '/public/pages/logout.svelte';
import ActivateAccount from '/public/pages/activate-account.svelte';
import TwoFASetup from '/public/pages/two-fa-setup.svelte';
import TwoFAChallenge from '/public/pages/two-fa-challenge.svelte';
import Kitchen from '/public/pages/sink/kitchen.svelte';
import NotFound from '/public/pages/not-found.svelte';
import TeamInvite from '/public/pages/team/TeamInvite.svelte';

const routes = [
    {
      name: '/',
      component: Home,
    },        
    {
        name: 'forgot-my-password',
        component: ForgotPassword
    },
    {
        name: 'password-reset/:hash',
        component: ResetPassword
    },
    {
      name: 'logout',
      component: Logout
    },
    {
        name: 'activate-account/:hash',
        component: ActivateAccount
    },
    {
        name: 'two-fa-setup/:hash',
        component: TwoFASetup
    },
    {
        name: 'two-fa-challenge/:hash',
        component: TwoFAChallenge
    },
    {
        name: 'sink',
        component: Kitchen
    },
    {
        name: 'team-invite/:hash',
        component: TeamInvite
    },
    {
        name: '404',
        path: '404',
        component: NotFound
    }
]

  export { routes }
